import { render, staticRenderFns } from "./GiftCodeGet.vue?vue&type=template&id=480463cc&scoped=true&"
import script from "./GiftCodeGet.vue?vue&type=script&lang=js&"
export * from "./GiftCodeGet.vue?vue&type=script&lang=js&"
import style0 from "./GiftCodeGet.vue?vue&type=style&index=0&id=480463cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480463cc",
  null
  
)

export default component.exports